<template>
  <div class="page">
    <!-- 头部 -->
    <YorkbbsHeader :width="'1170px'"></YorkbbsHeader>

    <div class="page-wrapper">
      <div class="card">
        <!-- 标题 -->
        <div class="title">发布黄页前，请先查找信息是否已存在</div>

        <!-- 搜索 -->
        <div class="search">
          <el-autocomplete
            class="autocomplete"
            ref="autocomplete"
            v-model="keyword"
            clearable
            :trigger-on-focus="false"
            :fetch-suggestions="onSuggestionFetch"
            @select="onSuggestionSelected"
            @keyup.enter.native="onSearchButtonClicked"
            placeholder="搜索商户名称、电话或地址，搜电话请输入纯数字"
          >
            <el-button slot="append" icon="el-icon-search" @click="onSearchButtonClicked"></el-button>
          </el-autocomplete>

          <div class="search-tip">
            <span>没有找到？</span>
            <router-link to="/publish">立即发布黄页</router-link>
          </div>
        </div>

        <!-- 列表 -->
        <div class="info-list">
          <YorkbbsClaimItem v-for="(item, i) in list" :key="i" :data="item"></YorkbbsClaimItem>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import YorkbbsHeader from '@/common/header/header.vue';
import YorkbbsClaimItem from './item-claim.vue';
export default {
  name: 'Claim',
  components: { YorkbbsHeader, YorkbbsClaimItem },
  data() {
    return {
      // 搜索关键词
      keyword: '',

      // 列表加载状态
      loading: false,
      // 黄页列表
      list: [],
    };
  },
  methods: {
    /**
     * 搜索
     */
    async onSuggestionFetch(keyword, cb) {
      const { data } = await this.$axios.post('/info/v1/get/post/by/name/phone', {
        keyword,
        size: 20,
      });

      const list = data.items.map(item => ({ ...item, value: item.property.shopCnName }));
      cb(list);
    },
    /**
     * 选择匹配项
     */
    onSuggestionSelected(value) {
      this.list = [value];
    },
    /**
     * 点击搜索按钮
     */
    async onSearchButtonClicked() {
      this.$refs.autocomplete.close();

      if (this.loading) return;

      this.loading = true;
      const { data } = await this.$axios
        .post('/info/v1/get/post/by/name/phone', {
          keyword: this.keyword,
          size: 20,
        })
        .finally(() => {
          this.loading = false;
        });

      this.showPublishButton = !data.items.length;
      this.list = data.items;
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.page-wrapper {
  width: 970px;
  margin: auto;
}

.card {
  margin-top: 30px;
  padding: 60px 50px;
  background: #ffffff;
  border-radius: 6px;
}

.title {
  font-size: 24px;
  font-weight: 500;
  text-align: center;
  color: var(--text-color-3);
  line-height: 33px;
  padding-top: 30px;
  padding-bottom: 40px;
}

.search {
  width: 600px;
  margin: auto;
  ::v-deep {
    .autocomplete {
      width: 100%;
      .el-input {
        border-radius: 6px 0px 0px 6px;
        box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
      }
      .el-input__inner {
        border: 0 none;
        height: 48px;
        line-height: 48px;
      }
      .el-input-group__append {
        border: 0 none;
        background-color: var(--primary-color);
        color: #fff;
        font-size: 20px;
        .el-button {
          padding-left: 0;
          padding-right: 0;
          width: 55px;
          text-align: center;
        }
      }
    }
  }
}

.search-tip {
  font-size: 16px;
  line-height: 22px;
  padding: 30px 0;
  span {
    color: var(--text-color-3);
  }
  a {
    color: var(--primary-color);
    text-decoration: underline;
    margin-left: 5px;
  }
}

.info-list {
  max-height: 500px;
  overflow-y: auto;
}
</style>
